import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { ThemeConstantService } from "src/app/shared/services/theme-constant.service";
import { AppsService } from "src/app/shared/services/apps.service";
import { AtomServiceService } from "src/app/shared/services/atom-service.service";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { NzMessageService } from "ng-zorro-antd/message";
import { MessageDialogComponent } from "../../../shared/components/message-dialog/message-dialog.component";
import { NzModalRef, NzModalService } from "ng-zorro-antd/modal";
// import {ToastrService } from 'ngx-toastr';
// import { NzNotificationService } from 'ng-zorro-antd';
import { Location } from "@angular/common";

@Component({
  selector: "app-asset-models",
  templateUrl: "./asset-models.component.html",
  styleUrls: ["./asset-models.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AssetModelsComponent implements OnInit {
  constructor(
    private fb: FormBuilder,
    private themeService: ThemeConstantService,
    public apiSrv: AppsService,
    public atmSrv: AtomServiceService,
    private message: NzMessageService,
    private modal: NzModalService,
    private location: Location,
    private nzMessageService: NzMessageService
  ) {}
  shwschvlymDelDiv;
  shwschvlymEditDiv;
  USER_PERMISSIONS: any = {
    slct_in: 0,
    insrt_in: 0,
    updt_in: 0,
    dlte_in: 0,
    exprt_in: 0,
  };
  usrAcsErrMsg: boolean = false;
  columnDefs;
  mainMessage;
  loader;
  gridData;
  shwSidebar;
  sidebarHeading;
  modelForm;
  shwLdng;
  editdata;
  delData;
  delete: boolean = false;
  ctgryLst;
  ngOnInit() {
    this.modelForm = new FormGroup({
      mdl_nm: new FormControl(""),
      mdl_cd: new FormControl(""),
      dscn_tx: new FormControl(""),
      ast_ctgry_id: new FormControl(""),
    });
    this.getGridData();
    this.getCategory();
  }
  getGridData() {
    // console.log('grid data called')
    this.mainMessage = null;
    this.loader = true;
    this.usrAcsErrMsg = false;
    this.apiSrv.get("asset/tracking/models").subscribe(
      (res) => {
        console.log(res);
        this.loader = false;
        if (res["status"] == 404) {
          this.usrAcsErrMsg = true;
        } else if (res["status"] == 200) {
          this.USER_PERMISSIONS = res["perm"][0];
          if (this.USER_PERMISSIONS.slct_in === 1) {
            // console.log(res['data'])
            // this.user.permissions = (res['perm'] === null) ? this.user.permissions : res['perm'][0];
            if (res["data"].length === 0) {
              this.mainMessage = "No entries found in the database.";
            }

            this.gridData = res["data"];
            // console.log(this.gridData)

            this.columnDefs = [
              {
                headerName: "Sno",
                field: "sno",
                alignment: "center",
                cellClass: "pm-grid-number-cell",
                width: 60,
                sortable: true,
                filter: false,
              },
              {
                headerName: "Model Name",
                field: "mdl_nm",
                alignment: "left",
                cellClass: "pm-grid-number-cell",
              },
              {
                headerName: "Model Code",
                field: "mdl_cd",
                alignment: "left",
                cellClass: "pm-grid-number-cell",
              },
              {
                headerName: "Description",
                field: "dscn_tx",
                alignment: "left",
                cellClass: "pm-grid-number-cell",
              },
              {
                headerName: "Asset Category",
                field: "wrk_ast_ctgry_nm",
                alignment: "left",
                cellClass: "pm-grid-number-cell",
                ortable: true,
                filter: true,
              },
              {
                headerName: "Creation Time",
                field: "i_ts",
                alignment: "center",
                cellClass: "pm-grid-number-cell",
                sortable: true,
                filter: true,
              },
              {
                headerName: "Updated Time",
                field: "u_ts",
                alignment: "center",
                cellClass: "pm-grid-number-cell",
                sortable: true,
                filter: true,
              },
              {
                headerName: "Created By",
                field: "crte_usr",
                alignment: "left",
                cellClass: "pm-grid-number-cell",
                sortable: true,
                filter: true,
              },
              {
                headerName: "Updated By",
                field: "updte_usr",
                alignment: "left",
                cellClass: "pm-grid-number-cell",
                sortable: true,
                filter: true,
              },
            ];
            // else if (res['status'] === 404) {
            //   let permTxt = 'Desginations Creation';
            //   let prmeRte = `user/permissions/${permTxt}`;
            //   this.crdsrv.get(prmeRte).subscribe((prmres) => {
            //   // console.log(prmres['data']);

            //   });
            //   // this.user.permissions = { 'slct_in': 0, 'insrt_in': 0, 'updt_in': 0, 'dlte_in': 0, 'exprt_in': 0 };
            // }
          } else {
            this.usrAcsErrMsg = true;
          }
        } else {
          //   this.toastr.error( res["message"], '', {
          //    timeOut: 10000,
          //    positionClass: 'toast-top-right',
          //  });
          this.message.error(res["message"], {
            nzDuration: 2000,
          });
        }
      },
      (err) => {
        this.loader = false;
      }
    );
  }
  onToolbarPreparing(e) {
    // console.log(e);
    e.toolbarOptions.items.unshift({
      location: "after",
      widget: "dxButton",
      options: {
        icon: "plus",
        text: "Add New Model",
        onClick: this.openSideBar.bind(this, "new"),
        bindingOptions: {
          disabled: "isEmailButtonDisabled",
        },
      },
    });
  }
  getCategory() {
    this.apiSrv.get("asset/tracking/categories").subscribe((res) => {
      this.ctgryLst = res["data"];
    });
  }
  openSideBar(opt, data) {
    this.shwSidebar = true;
    this.modelForm.value.mdl_nm = "";
    this.modelForm.value.dscn_tx = "";
    if (opt == "edit") {
      this.shwschvlymEditDiv = true;
      this.shwschvlymDelDiv = false;
      this.sidebarHeading = "Edit Group";
      this.modelForm.get("mdl_nm").setValue(data.mdl_nm);
      this.modelForm.get("mdl_cd").setValue(data.mdl_cd);
      this.modelForm.get("dscn_tx").setValue(data.dscn_tx);
      this.modelForm.get("ast_ctgry_id").setValue(data.ast_ctgry_id);
    } else if (opt == "delete") {
      this.shwschvlymEditDiv = false;
      this.shwschvlymDelDiv = true;
      this.sidebarHeading = "Delete Group";
    } else {
      this.shwschvlymEditDiv = false;
      this.shwschvlymDelDiv = false;
      this.sidebarHeading = "Add New Group";
      this.delete = false;
    }
  }
  closeSideBar(): void {
    this.shwSidebar = false;
  }
  goBack() {
    this.location.back();
  }
  saveDeleteModel() {
    this.shwLdng = true;
    this.apiSrv.delete(`asset/tracking/model/${this.delData.mdl_id}`).subscribe(
      (res) => {
        this.shwLdng = false;
        if (res["status"] == 200) {
          // this.toastr.success('Model Deleted Successfully', '', {
          //   timeOut: 3000,
          // });
          this.message.success("Model Deleted Successfully", {
            nzDuration: 2000,
          });
          this.cancel();
        } else {
          // this.toastr.error(res['message'], '', {
          //   timeOut: 3000
          // });
          this.message.error(res["message"], {
            nzDuration: 2000,
          });
        }
      },
      (err) => {
        this.shwLdng = false;
        this.message.error(
          "Something Went Wrong. Please contact the administrator",
          {
            nzDuration: 2000,
          }
        );
        // this.toastr.error('Something Went Wrong. Please contact the administrator', '', {
        //   timeOut: 3000
        // });
      }
    );
  }
  saveEditModel() {
    let data = {
      mdl_nm: this.modelForm.value.mdl_nm,
      mdl_cd: this.modelForm.value.mdl_cd,
      dscn_tx: this.modelForm.value.dscn_tx,
      ast_ctgry_id: this.modelForm.value.ast_ctgry_id,
    };
    console.log(this.editdata);
    console.log(data);
    if (
      data.mdl_nm != "" &&
      data.dscn_tx != "" &&
      data.mdl_cd != "" &&
      data.ast_ctgry_id != ""
    ) {
      this.shwLdng = true;
      this.apiSrv
        .update(data, `asset/tracking/model/${this.editdata.mdl_id}`)
        .subscribe(
          (res) => {
            this.shwLdng = false;
            if (res["status"] == 200) {
              this.message.success("Model Updated Successfully", {
                nzDuration: 2000,
              });
              // this.toastr.success('Model Updated Successfully', '', {
              //   timeOut: 3000,
              // });
              this.cancel();
            } else {
              // this.toastr.error(res['message'], '', {
              //   timeOut: 3000
              // });
              this.message.error(res["message"], {
                nzDuration: 2000,
              });
            }
          },
          (err) => {
            this.shwLdng = false;
            // this.toastr.error('Something Went Wrong. Please contact the administrator', '', {
            //   timeOut: 3000
            // });
            this.message.error(
              "Something Went Wrong. Please contact the administrator",
              {
                nzDuration: 2000,
              }
            );
          }
        );
    } else {
      // this.toastr.warning('Please Enter Required Fields Correctly', '', {
      //   timeOut: 3000
      // });
      this.message.error("Please Enter Required Fields Correctly", {
        nzDuration: 2000,
      });
    }
  }
  saveModel() {
    console.log(this.modelForm.value);
    let data = {
      mdl_nm: this.modelForm.value.mdl_nm,
      mdl_cd: this.modelForm.value.mdl_cd,
      dscn_tx: this.modelForm.value.dscn_tx,
      ast_ctgry_id: this.modelForm.value.ast_ctgry_id,
    };
    console.log(data);
    if (
      data.mdl_nm != "" &&
      data.dscn_tx != "" &&
      data.mdl_cd != "" &&
      data.ast_ctgry_id != ""
    ) {
      this.shwLdng = true;
      this.apiSrv.create(data, `asset/tracking/model`).subscribe(
        (res) => {
          this.shwLdng = false;
          if (res["status"] == 200) {
            // this.toastr.success('Model Created Successfully', '', {
            //   timeOut: 3000,
            // });
            this.message.success("Model Created Successfully", {
              nzDuration: 2000,
            });
            this.cancel();
          } else {
            // this.toastr.error(res['message'], '', {
            //   timeOut: 3000
            // });
            this.message.error(res["message"], {
              nzDuration: 2000,
            });
          }
        },
        (err) => {
          this.shwLdng = false;
          // this.toastr.error('Something Went Wrong. Please contact the administrator', '', {
          //   timeOut: 3000
          // });
          this.message.error(
            "Something Went Wrong. Please contact the administrator",
            {
              nzDuration: 2000,
            }
          );
        }
      );
    } else {
      // this.toastr.warning('Please Enter Required Fields Correctly', '', {
      //   timeOut: 3000
      // });
    }
    console.log(data);
  }
  onDelete2(event) {
    this.delete = true;
    this.delData = event.data;
    this.openSideBar("delete", this.delData);
  }
  onEdit2(event) {
    this.delete = false;
    this.editdata = event.data;
    this.openSideBar("edit", this.editdata);
  }
  cancel() {
    this.modelForm.reset();
    this.shwSidebar = false;
    this.getGridData();
  }
  oncancel(): void {
    this.nzMessageService.info("Model Not Deleted");
  }
}
